import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "how-tos"
    }}>{`How Tos`}</h1>
    <p>
      <p>{`The `}<a parentName="p" {...{
          "href": "electronic-seal-api.md/#apply-electronic-seal-with-default-appearance-on-pdf"
        }}>{`samples and documentation`}</a>{` should get you quickly up and running with PDF Electronic Seal capabilities in the `}<a parentName="p" {...{
          "href": "../../pdf-services-api/index.md"
        }}>{`PDFServices SDK`}</a>{` including:`}</p>
      <ul>
        <li parentName="ul">{`Applying Electronic Seal on PDFs`}</li>
      </ul>
      <p>{`For code examples illustrating other PDF actions including those below, see the `}<a parentName="p" {...{
          "href": "../../pdf-services-api/index.md"
        }}>{`PDFServices SDK`}</a>{` :`}</p>
      <ul>
        <li parentName="ul">{`Creating a PDF from multiple formats, including HTML, Microsoft Office documents, and text files`}</li>
        <li parentName="ul">{`Exporting a PDF to other formats or an image`}</li>
        <li parentName="ul">{`Combining entire PDFs or specified page ranges`}</li>
        <li parentName="ul">{`Using OCR to make a PDF file searchable with a custom locale`}</li>
        <li parentName="ul">{`Compress PDFs with compression level and Linearize PDFs`}</li>
        <li parentName="ul">{`Protect PDFs with password(s) and Remove password protection from PDFs`}</li>
        <li parentName="ul">{`Common page operations, including inserting, replacing, deleting, reordering, and rotating`}</li>
        <li parentName="ul">{`Splitting PDFs into multiple files`}</li>
      </ul>
    </p>
    <h2 {...{
      "id": "custom-timeout-configuration"
    }}>{`Custom timeout configuration`}</h2>
    <p>{`The APIs use inferred timeout properties and provide defaults. However,
the SDK supports custom timeouts for the API calls. You can tailor the
timeout settings for your environment and network speed. In addition to
the details below, you can refer to working code samples:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/adobe/pdfservices-java-sdk-samples/blob/master/src/main/java/com/adobe/pdfservices/operation/samples/customconfigurations/CreatePDFWithCustomTimeouts.java"
        }}>{`Java`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/adobe/PDFServices.NET.SDK.Samples/blob/master/CreatePDFWithCustomTimeouts/Program.cs"
        }}>{`.NET`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/adobe/pdfservices-node-sdk-samples/blob/master/src/customconfigurations/create-pdf-with-custom-timeouts.js"
        }}>{`Node.js`}</a></li>
    </ul>
    <h3 {...{
      "id": "java-timeout-configuration"
    }}>{`Java timeout configuration`}</h3>
    <p>{`Available properties:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`connectTimeout`}</strong>{`: Default: 2000. The maximum allowed time in
milliseconds for creating an initial HTTPS connection.`}</li>
      <li parentName="ul"><strong parentName="li">{`socketTimeout`}</strong>{`: Default: 10000. The maximum allowed time in
milliseconds between two successive HTTP response packets.`}</li>
      <li parentName="ul"><strong parentName="li">{`processingTimeout`}</strong>{`: Default: 600000. The maximum allowed time
in milliseconds for processing the documents. Any operation taking more time than the specified `}<inlineCode parentName="li">{`processingTimeout`}</inlineCode>{` will result in an operation timeout exception.`}
        <ul parentName="li">
          <li parentName="ul"><strong parentName="li">{`Note :`}</strong>{` It is advisable to set the `}<inlineCode parentName="li">{`processingTimeout`}</inlineCode>{` to higher values for processing large files.`}</li>
        </ul>
      </li>
    </ul>
    <p>{`Override the timeout properties via a custom `}<inlineCode parentName="p">{`ClientConfig`}</inlineCode>{` class:`}</p>
    <CodeBlock slots="heading, code" repeat="1" languages="Java" mdxType="CodeBlock" /> 
    <h3 {...{
      "id": ""
    }}></h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`ClientConfig clientConfig = ClientConfig.builder()
    .withConnectTimeout(3000)
    .withSocketTimeout(20000)
    .build();
`}</code></pre>
    <h3 {...{
      "id": "net-timeout-configuration"
    }}>{`.NET timeout configuration`}</h3>
    <p>{`Available properties:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`timeout`}</strong>{`: Default: 400000. The maximum allowed time in
milliseconds for establishing a connection, sending a request, and
getting a response.`}</li>
      <li parentName="ul"><strong parentName="li">{`readWriteTimeout`}</strong>{`: Default: 10000. The maximum allowed time in
milliseconds to read or write data after connection is established.`}</li>
      <li parentName="ul"><strong parentName="li">{`processingTimeout`}</strong>{`: Default: 600000. The maximum allowed time
in milliseconds for processing the documents. Any operation taking more time than the specified `}<inlineCode parentName="li">{`processingTimeout`}</inlineCode>{` will result in an operation timeout exception.`}
        <ul parentName="li">
          <li parentName="ul"><strong parentName="li">{`Note :`}</strong>{` It is advisable to set the `}<inlineCode parentName="li">{`processingTimeout`}</inlineCode>{` to higher values for processing large files.`}</li>
        </ul>
      </li>
    </ul>
    <p>{`Override the timeout properties via a custom `}<inlineCode parentName="p">{`ClientConfig`}</inlineCode>{` class:`}</p>
    <CodeBlock slots="heading, code" repeat="1" languages=".NET" mdxType="CodeBlock" />
    <h3 {...{
      "id": "-1"
    }}></h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`ClientConfig clientConfig = ClientConfig.ConfigBuilder()
    .timeout(500000)
    .readWriteTimeout(15000)
    .Build();
`}</code></pre>
    <h3 {...{
      "id": "nodejs-timeout-configuration"
    }}>{`Node.js timeout configuration`}</h3>
    <p>{`Available properties:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`connectTimeout`}</strong>{`: Default: 10000. The maximum allowed time in
milliseconds for creating an initial HTTPS connection.`}</li>
      <li parentName="ul"><strong parentName="li">{`readTimeout`}</strong>{`: Default: 10000. The maximum allowed time in
milliseconds between two successive HTTP response packets.`}</li>
      <li parentName="ul"><strong parentName="li">{`processingTimeout`}</strong>{`: Default: 600000. The maximum allowed time
in milliseconds for processing the documents. Any operation taking more time than the specified `}<inlineCode parentName="li">{`processingTimeout`}</inlineCode>{` will result in an operation timeout exception.`}
        <ul parentName="li">
          <li parentName="ul"><strong parentName="li">{`Note :`}</strong>{` It is advisable to set the `}<inlineCode parentName="li">{`processingTimeout`}</inlineCode>{` to higher values for processing large files.`}</li>
        </ul>
      </li>
    </ul>
    <p>{`Override the timeout properties via a custom `}<inlineCode parentName="p">{`ClientConfig`}</inlineCode>{` class:`}</p>
    <CodeBlock slots="heading, code" repeat="1" languages="Node JS" mdxType="CodeBlock" />
    <h3 {...{
      "id": "-2"
    }}></h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const clientConfig = PDFServicesSdk.ClientConfig
    .clientConfigBuilder()
    .withConnectTimeout(15000)
    .withReadTimeout(15000)
    .build();
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      